import React, { useContext } from 'react'
import { useParams } from 'react-router-dom';
import { XRouterNavigateContext } from '../common/seo/xrouter/XRouterNavigateContext';
import { urls } from '..';
import { getTorneiInEvidenza } from '../data/utils/getTorneiInEvidenza';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import { useIsDateSection } from '../common/IsDateSectionProvider';

export const TournamentsSectionNewWh = () => {
    const xrouterNavigateContext = useContext(XRouterNavigateContext);
    const isDateSection = useIsDateSection();
    const params = useParams();
    const prematchData = usePrematchData();
    const highlights = getTorneiInEvidenza(prematchData.sport, 'ALL');
    const tournamentsCount = highlights.tournamentsList.length;

    if (tournamentsCount === 0) {
        return null;
    }

    return (<>
        <div className='tournamentsSection__wrapper'>
            {highlights.sportsList.map((sport) => {
                const icoSport = iconSportCssClass(sport.id, sport.iconClass);

                return sport.competitions.map(e => {
                    function handleClick() {
                        if (isDateSection) {
                            xrouterNavigateContext.navigate(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${params.date}/${params.sportId}/${params.aggId}/${e.id}`, { data: e });
                        } else {
                            xrouterNavigateContext.navigate(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${e.uniqueId}`, { data: e });
                        }
                    }

                    return <div key={e.uniqueId} onClick={handleClick} className='flex row tournamentsSection__items justify-between items-center'>
                        <div className='flex flex-row items-center gap-1'>
                            <div className={`xs-sport-icon h-[24px] w-[24px] cms-setted-sport- ${icoSport}`}></div>
                            <div className="tournamentsLanding--title">{e.desc?.length > 0 ? e.desc : e.descrizione}</div>
                        </div>
                        <div><svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.58499 0.831042C2.58499 0.744432 2.61867 0.668133 2.68466 0.60077L3.18576 0.0996701C3.25175 0.0336817 3.32874 0 3.41535 0C3.50196 0 3.57826 0.0336817 3.64562 0.0996701L8.31568 4.76973C8.38166 4.83709 8.41535 4.91339 8.41535 5C8.41535 5.08661 8.38166 5.1636 8.31568 5.23027L3.64562 9.90033C3.57963 9.96632 3.50196 10 3.41535 10C3.32874 10 3.25175 9.96632 3.18507 9.90033L2.68535 9.39923C2.61936 9.33187 2.58568 9.25557 2.58568 9.16896C2.58568 9.08235 2.61936 9.00605 2.68535 8.93868L6.62335 5.00069L2.68535 1.06269C2.61936 0.996701 2.58568 0.919714 2.58568 0.833104V0.830355L2.58499 0.831042Z" fill="#546D91" />
                        </svg>
                        </div>
                    </div>
                })
            })}
        </div></>
    )
}
